const AboutUs = () => {
    return(
        <>
        
        <div className="about">
            <div className="header">
                <h1>About Us</h1>
            </div>
            <div className="abtpg">
            <div className="abtflex-1">
                
                <div><span>About Coffee</span><br></br> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nemo magni quidem quisquam eligendi sunt distinctio reiciendis iure adipisci pariatur earum. Doloremque officia sed, quaerat obcaecati dignissimos architecto, esse vel neque nisi cum animi voluptatum numquam, voluptate hic earumdignissimos architecto, esse vel neque nisi cum animi voluptatum numquam, voluptate hic earum debitis sint eius dolore atque nesciunt aliquid est dicta odio. Recusandae, labore </div>
                <div className="abtimg">
                    <img src="images/about-1.jpg" alt="" />
                </div>
            </div>
            <div className="abtflex-1">
            <div className="abtimg-2">
                    <img src="images/about-22.jpg" alt="" />
                </div>
                <div><span>About Founder</span><br></br> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nemo magni quidem quisquam eligendi sunt distinctio reiciendis iure adipisci pariatur earum. Doloremque officia sed, quaerat obcaecati dignissimos architecto, esse vel neque nisi cum animi voluptatum numquam, voluptate hic earumdignissimos architecto, esse vel neque nisi cum animi voluptatum numquam, voluptate hic earum debitis sint eius dolore atque nesciunt aliquid est dicta odio. Recusandae, labore </div>
                
            </div>
            </div>
        </div>
        
        </>
    )
};


export default AboutUs;